import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  rootModal: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '82vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(900)]: {
      paddingTop: '75px',
    },
    [theme.breakpoints.down(790)]: {
      paddingTop: '110px',
    },
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '31vh',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  tablesContainer: {
    maxHeight: '30vh !important',
    overflowX: 'hidden',
    paddingBottom: '5px'
  },
  rootFormModal: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '2rem',
    marginBottom: '3%',
    overflowX: 'hidden',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginLeft: '19%',
    overflowX: 'hidden',
    height: '57vh !important',
    position: 'relative',
  },
  inputEmail: {
    textTransform: 'lowercase',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  registerBtn: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-end',
    margin: '16px 0 24px',
    alignItems: 'flex-start',
  },
  button: {
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    textDecoration: 'none',
    cursor: 'pointer',
    width: '110px',
    backgroundColor: '#026894',
    color: '#fff',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: '16px',
    '&:hover': {
      backgroundColor: '#064561',
    },
  },
  buttonVisualize: {
    marginRight: '16px',
  },
  accordionRoot: {
    boxShadow: 'none',
    borderBottom: 'none',
  },
  inputSalario: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '7px',
    paddingBottom: '7px',
    paddingLeft: '1%',
    paddingRight: '5px',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputText: {
    textTransform: 'uppercase',
  },
  large: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#FFF',
    marginBottom: '2%',
    color: '#949494',
  },
  input2: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '38px',
    textTransform: 'uppercase',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '10px',
    fontSize: '16px',
    opacity: '100%',
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '99%',
    backgroundColor: '#FFF',
    marginBottom: '2%',
    borderRadius: '4px',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  small: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '93%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  small_date: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputTime: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '6%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputSelectDate: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '40px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '4%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'right',
    alignItems: 'flex-end',
  },
  itemSmall: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'right',
    alignItems: 'flex-start',
  },
  summary: {
    backgroundColor: '#C4C4C4',
    borderRadius: '5px',
  },
  details: {
    backgroundColor: '#ECECEC',
  },
  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  grid2: {
    display: 'block',
  },
  divButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '3%',
    marginBottom: '3%',
  },
  selectBox: {
    float: 'left',
    width: '97%',
    color: '#6161ff',
    backgroundColor: '#fff',
    textDecoration: 'underline',
    height: '43px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '15px',
    borderRadius: '5px',
    cursor: 'pointer',
    borderWidth: 0,
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
  porcentage: {
    marginRight: '5px',
    borderBottom: '1px solid',
    flex: 1,
    height: '45px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  divLogo: {
    background: '#fff',
    padding: '12px',
    width: '92%',
    marginBottom: '14px',
  },
  cnpjBox: {
    display: 'grid',
    gridTemplateColumns: '96px 1fr',
    width: '98%',
  },
}));

export default useStyles;